module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_06_beach-photo-7aa1dd44ecad422347527729db949f91.jpg";